import { gql } from "@apollo/client";

export const schema = {

    // user interview 
    // delete user interview
    scoreInterview: (query: string) => gql`
        mutation scoreInterview($userInterview: UserInterviewInput!, $userQuestionAnswers: [UserQuestionAnswersInput]!) {
            scoreInterview(userInterview: $userInterview, userQuestionAnswers: $userQuestionAnswers) {
                ${query}
            }
        }
    `,
    deleteUserInterview: (query: string) => gql`
        mutation deleteUserInterview($userInterviewId: String!) {
            deleteUserInterview(userInterviewId: $userInterviewId) {
                ${query}
            }
        }
    `,
    // update interview 
    updateUserInterview: (query: string) => gql`
        mutation updateUserInterview($userInterviewId: String!, $userInterview: UserInterviewInput!) {
            updateUserInterview(userInterviewId: $userInterviewId, userInterview: $userInterview) {
                ${query}
            }
        }
    `,
    // add interview 
    createUserInterview: (query: string) => gql`
        mutation createUserInterview($userInterview: UserInterviewInput!) {
            createUserInterview(userInterview: $userInterview) {
                ${query}
            }
        }
    `,
    // get user interview 
    getUserInterviews: (query: string) => gql`
        query getUserInterviews($userInterviewIds: [String], $userInterview: UserInterviewInput, $search: String, $limit: Int!, $skip: Int!){
            getUserInterviews(userInterviewIds: $userInterviewIds, userInterview: $userInterview, search: $search, limit: $limit, skip: $skip){
                ${query}
            }
        }
    `,
    // get user interview
    getUserInterview: (query: string) => gql`
        query getUserInterview($userInterview: UserInterviewInput!){
            getUserInterview(userInterview: $userInterview){
                ${query}
            }
        }
    `,
    // interview 
    // delete interview 
    deleteInterview: (query: string) => gql`
        mutation deleteInterview($interviewId: String!) {
            deleteInterview(interviewId: $interviewId) {
                ${query}
            }
        }
    `,
    // update interview 
    updateInterview: (query: string) => gql`
        mutation updateInterview($interviewId: String!, $interview: InterviewInput!){
            updateInterview(interviewId: $interviewId, interview: $interview){
                ${query}
            }
        }
    `,
    updateInterviewUnified: (query: string) => gql`
        mutation updateInterviewUnified($interviewId: String!, $updateInterviewRequest: UpdateInterviewRequestInput, $updateQuestionRequest: [UpdateQuestionRequestInput], $updateQuestionOptionRequest: [UpdateQuestionOptionRequestInput], $updateQuestionAnswerRequest: [UpdateQuestionAnswerRequestInput], $addQuestionRequest: [AddQuestionRequestInput], $addQuestionOptionRequest: [AddQuestionOptionRequestInput], $addQuestionAnswerRequest: [AddQuestionAnswerRequestInput]){
            updateInterviewUnified(interviewId: $interviewId, updateInterviewRequest: $updateInterviewRequest, updateQuestionRequest: $updateQuestionRequest, updateQuestionOptionRequest: $updateQuestionOptionRequest, updateQuestionAnswerRequest: $updateQuestionAnswerRequest, addQuestionRequest: $addQuestionRequest, addQuestionOptionRequest: $addQuestionOptionRequest, addQuestionAnswerRequest: $addQuestionAnswerRequest){
                ${query}
            }
        }
    `,
    // add interview 
    createInterview: (query: string) => gql`
        mutation createInterview($interview: InterviewInput!, $questionRequests: [QuestionRequestsInput]!, $questionAnswers: [QuestionAnswersInput]!) {
            createInterview(interview: $interview, questionRequests: $questionRequests, questionAnswers: $questionAnswers) {
                ${query}
            }
        }
    `,
    // get interviews 
    getInterviews: (query: string) => gql`
        query getInterviews($search: String, $interviewIds: [String], $interview: InterviewInput, $limit: Int!, $skip: Int!){
            getInterviews(search: $search, interviewIds: $interviewIds, interview: $interview, limit: $limit, skip: $skip){
                ${query}
            }
        }
    `,
    // get interview
    getInterview: (query: string) => gql`
        query getInterview($interview: InterviewInput!) {
            getInterview(interview: $interview) {
                ${query}
            }
        }
    `,

    // Quiz
    updateQuizUnified: (query: string) => gql`
        mutation updateQuizUnified($quizId: String!, $updateQuizRequest: UpdateQuizRequestInput, $updateQuestionRequest: [UpdateQuestionRequestInput], $updateQuestionOptionRequest: [UpdateQuestionOptionRequestInput], $updateQuestionAnswerRequest: [UpdateQuestionAnswerRequestInput], $addQuestionRequest: [AddQuestionRequestInput], $addQuestionOptionRequest: [AddQuestionOptionRequestInput], $addQuestionAnswerRequest: [AddQuestionAnswerRequestInput]){
            updateQuizUnified(quizId: $quizId, updateQuizRequest: $updateQuizRequest, updateQuestionRequest: $updateQuestionRequest, updateQuestionOptionRequest: $updateQuestionOptionRequest, updateQuestionAnswerRequest: $updateQuestionAnswerRequest, addQuestionRequest: $addQuestionRequest, addQuestionOptionRequest: $addQuestionOptionRequest, addQuestionAnswerRequest: $addQuestionAnswerRequest){
                ${query}
            }
        }
    `,
    createQuiz: (query: string) => gql`
        mutation createQuiz($quiz: QuizInput!, $questionRequests: [QuestionRequestsInput]!, $questionAnswers: [QuestionAnswersInput]!) {
            createQuiz(quiz: $quiz, questionRequests: $questionRequests, questionAnswers: $questionAnswers) {
                ${query}
            }
        }
    `,
    getQuizYears: (query: string) => gql`
        query getQuizYears($courseId: String!) {
            getQuizYears(courseId: $courseId) {
                ${query}
            }
        }
    `,
    deleteQuizAndGetQuizYears: (query: string) => gql`
        mutation deleteQuizAndGetQuizYears($quizId: String!, $courseId: String!) {
            deleteQuizAndGetQuizYears(quizId: $quizId, courseId: $courseId) {
                ${query}
            }
        }
    `,
    getQuiz: (query: string) => gql`
        query getQuiz($quiz: QuizInput!) {
            getQuiz(quiz: $quiz) {
                ${query}
            }
        }
    `,
    getQuizzes: (query: string) => gql`
        query getQuizzes($search: String, $quizIds: [String], $quiz: QuizInput, $limit: Int!, $skip: Int!) {
            getQuizzes(search: $search, quizIds: $quizIds, quiz: $quiz, limit: $limit, skip: $skip) {
                ${query}
            }
        }
    `,
    scoreQuiz: (query: string) => gql`
        mutation scoreQuiz($userQuiz: UserQuizInput!, $userQuestionAnswers: [UserQuestionAnswersInput]!) {
            scoreQuiz(userQuiz: $userQuiz, userQuestionAnswers: $userQuestionAnswers) {
                ${query}
            }
        }
    `,
    getUserQuizzes: (query: string) => gql`
        query getUserQuizzes($search: String, $userQuizIds: [String], $userQuiz: UserQuizInput, $limit: Int!, $skip: Int!) {
            getUserQuizzes(search: $search, userQuizIds: $userQuizIds, userQuiz: $userQuiz, limit: $limit, skip: $skip) {
                ${query}
            }
        }
    `,
    getUserQuestionAnswers: (query: string) => gql`
        query getUserQuestionAnswers($search: String, $userQuestionAnswerIds: [String], $userQuestionAnswer: UserQuestionAnswerInput, $limit: Int!, $skip: Int!) {
            getUserQuestionAnswers(search: $search, userQuestionAnswerIds: $userQuestionAnswerIds, userQuestionAnswer: $userQuestionAnswer, limit: $limit, skip: $skip) {
                ${query}
            }
        }
    `,
    // Course Modules 
    addLessons: (query: string) => gql`
        mutation addLessons($lessons: [LessonInput]!) {
            addLessons(lessons: $lessons) {
                ${query}
            }
        }
    `,
    updateLessons: (query: string) => gql`
        mutation updateLessons($lessonUpdateRequests: [LessonUpdateRequestsInput]!) {
            updateLessons(lessonUpdateRequests: $lessonUpdateRequests) {
                ${query}
            }
        }
    `,


    // Course Module
    getCourseModuleCount: (query: string) => gql`
        query getCourseModuleCount($courseModule: CourseModuleInput!){
            getCourseModuleCount(courseModule: $courseModule){
                ${query}
            }
        }
    `,
    addCourseModules: (query: string) => gql`
        mutation addCourseModules($courseModuleAddRequests: [CourseModuleAddRequestsInput]!) {
            addCourseModules(courseModuleAddRequests: $courseModuleAddRequests) {
                ${query}
            }
        }
    `,

    updateCourseModules: (query: string) => gql`
        mutation updateCourseModules($courseModuleUpdateRequests: [CourseModuleUpdateRequestsInput]!) {
            updateCourseModules(courseModuleUpdateRequests: $courseModuleUpdateRequests) {
                ${query}
            }
        }
    `,

    getCourseModules: (query: string) => gql`
        query getCourseModules($search: String, $courseModuleIds: [String], $courseModule: CourseModuleInput, $limit: Int!, $skip: Int!) {
            getCourseModules(search: $search, courseModuleIds: $courseModuleIds, courseModule: $courseModule, limit: $limit, skip: $skip) {
                ${query}
            }
        }
    `,

    getCourseModule: (query: string) => gql`
        query getCourseModule($courseModule: CourseModuleInput!) {
            getCourseModule(courseModule: $courseModule) {
                ${query}
            }
        }
    `,

    deleteCourseModule: (query: string) => gql`
        mutation deleteCourseModule($courseModuleId: String!) {
            deleteCourseModule(courseModuleId: $courseModuleId) {
                ${query}
            }
        }
    `,

    // User Course
    createUserCourse: (query: string) => gql`
        mutation createUserCourse($userCourse: UserCourseInput!){
            createUserCourse(userCourse: $userCourse){
                ${query}
            }
        }
    `,

    updateUserCourse: (query: string) => gql`
        mutation updateUserCourse($userCourseId: String!, $userCourse: UserCourseInput!) {
            updateUserCourse(userCourseId: $userCourseId, userCourse: $userCourse) {
                ${query}
            }
        }
    `,  
    
    getUserCourses: (query: string) => gql`
        query getUserCourses($search: String, $userCourseIds: [String], $userCourse: UserCourseInput, $limit: Int!, $skip: Int!) {
            getUserCourses(search: $search, userCourseIds: $userCourseIds, userCourse: $userCourse, limit: $limit, skip: $skip) {
                ${query}
            }
        }
    `,
    getUserCourse: (query: string) => gql`
        query getUserCourse($userCourse: UserCourseInput!) {
            getUserCourse(userCourse: $userCourse) {
                ${query}
            }
        }
    `,


    updateCourse: (query: string) => gql`
        mutation updateCourse($courseId: String!, $course: CourseInput!) {
            updateCourse(courseId: $courseId, course: $course) {
                ${query}
            }
        }
    `,

    createCourse: (query: string) => gql`
        mutation createCourse($course: CourseInput!, $courseModulesRequest: [CourseModulesRequestInput]!) {
            createCourse(course: $course, courseModulesRequest: $courseModulesRequest) {
                ${query}
            }
        }
    `,
    getRecommendedCourses: (query: string) => gql`
        query getRecommendedCourses($userId: String!) {
            getRecommendedCourses(userId: $userId) {
                ${query}
            }
        }
    `,
    getCourse: (query: string) => gql`
        query getCourse($course: CourseInput!) {
            getCourse(course: $course) {
                ${query}
            }
        }
    `,
    getCourses: (query: string) => gql`
        query getCourses($search: String, $courseIds: [String], $course: CourseInput, $limit: Int!, $skip: Int!) {
            getCourses(search: $search, courseIds: $courseIds, course: $course, limit: $limit, skip: $skip) {
                ${query}
            }
        }
    `,
    deleteCourse: (query: string) => gql`
        mutation deleteCourse($courseId: String!) {
            deleteCourse(courseId: $courseId) {
                ${query}
            }
        }
    `,

    // Question Answers 
    getQuestionAnswers: (query: string) => gql`
        query getQuestionAnswers($search: String, $questionAnswerIds: [String], $questionAnswer: QuestionAnswerInput, $limit: Int!, $skip: Int!) {
            getQuestionAnswers(search: $search, questionAnswerIds: $questionAnswerIds, questionAnswer: $questionAnswer, limit: $limit, skip: $skip) {
                ${query}
            }
        }
    `,

    // Questions 
    getQuestions: (query: string) => gql`
        query getQuestions($search: String, $questionIds: [String], $question: QuestionInput, $limit: Int!, $skip: Int!) {
            getQuestions(search: $search, questionIds: $questionIds, question: $question, limit: $limit, skip: $skip) {
                ${query}
            }
        }
    `,
    deleteQuestionsByQuizId: (query: string) => gql`
        mutation deleteQuestionsByQuizId($quizId: String!) {
            deleteQuestionsByQuizId(quizId: $quizId) {
                ${query}
            }
        }
    `,
    deleteQuestionOption: (query: string) => gql`
        mutation deleteQuestionOption($questionOptionId: String!) {
            deleteQuestionOption(questionOptionId: $questionOptionId) {
                ${query}
            }
        }
    `,

    // dashboard course statistics
    getCourseStat: (query: string) => gql`
        query getCourseStat {
            getCourseStat { 
                ${query}
            }
        }
    `,
}
